import Icon from "../Icon";
import styles from "./Divider.module.css";

type Props = {
  text?: string;
  color?: string;
  iconName?: string;
};

function Divider({ text, color, iconName }: Props) {
  return (
    <div className={styles["divider-container"]} style={{ color }}>
      <div>
        {iconName && <Icon name={iconName} size="1rem" />}
        {text && <p>{text}</p>}
      </div>
      <div className={styles.divider} style={{ backgroundColor: color }}></div>
    </div>
  );
}
export default Divider;
